import { Trans, useTranslation } from "react-i18next";
import './ActivateCloudStorage.css';
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { useCallback, useEffect, useState } from "react";
import Button from "src/Components/Button/Button";
import Info from "src/images/info.png";
import ActivateCloudStoragePopup from "../ActivateCloudStoragePopup/ActivateCloudStoragePopup";
import { useActivateCloudStorage } from "src/Utils/Hooks/ManageLicenses/useActivateCloudStorage";
import SmallDialog from "src/Components/Dialog/SmallDialog";
import { useClinicContext } from "src/Utils/Hooks/ClinicContext";

type IActivateCloudStorage = {
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    isStorageDeactivated: boolean;
    disableActivateCloudStorage: boolean;
}

const ActivateCloudStorage: React.FC<IActivateCloudStorage> = ({ clinicId, setInfo, updatePageLoader, isStorageDeactivated, disableActivateCloudStorage }) => {
    const { t } = useTranslation();
    const [showActivateCloudPopup, setShowActivateCloudPopup] = useState<boolean>(false);
    const [appToRestart, setAppRestart] = useState(false);
    const { reqestResponse, reqestError, reqestLoading, activateCloudStorage } = useActivateCloudStorage();
    const { currentUser } = useClinicContext();

    const handleActivateCloudStorage = useCallback(() => {
        activateCloudStorage(clinicId);
    }, [clinicId, activateCloudStorage]);

    useEffect(() => {
        if (reqestError !== '') {
            setInfo(reqestError, InfoMessageType.error);
            setShowActivateCloudPopup(false);
        }
    }, [reqestError, setInfo]);

    useEffect(() => {
        if (reqestResponse) { 
            setShowActivateCloudPopup(false);
            setInfo('License activated successfully.', InfoMessageType.success);
            setAppRestart(true)
        }
    }, [reqestResponse, setInfo]);

    useEffect(() => {
        updatePageLoader(reqestLoading);
    }, [reqestLoading, updatePageLoader]);

    return (
        <>
            {
                showActivateCloudPopup &&
                <ActivateCloudStoragePopup
                    onActivate={handleActivateCloudStorage}
                    onClose={() => { setShowActivateCloudPopup(false) }}
                />
            }
            {
                appToRestart &&
                <SmallDialog
                    hideCancelButton={true}
                    submitButtonText={t("OK")}
                    title={t('RestartAuraApp')}
                    onClose={() => { }}
                    onSubmit={() => {setAppRestart(false) }}>
                    <div className="mt-2" style={{ textAlign: 'center' }}>
                        <Trans i18nKey='RestartAuraAppInstruction' />
                    </div>
                </SmallDialog>
            }
            <div className="d-flex" style={{ width: '98%' }}>
                <div className="d-flex align-items-center" style={{ flex: 2 }}>
                    {t('ActivateLicenseBanner')}
                    &nbsp;
                    <div data-tooltip={t('ActivateLicenseTooltip')} data-flow="bottom" style={{ width: '40px', height: '40px', borderRadius: '100%', marginBottom: '3px' }} className="d-flex justify-content-center align-items-center infoHover">
                        <span>
                            <img src={Info} alt="Info" />
                        </span>
                    </div>
                </div>
                {isStorageDeactivated &&
                    <div className="d-flex justify-content-end">
                        <Button
                            text={t('ActivateCloud')}
                            onClick={() => { setShowActivateCloudPopup(true) }}
                            disable={!currentUser?.isClinicAdmin || disableActivateCloudStorage}
                        />
                    </div>
                }
            </div>
        </>
    );
}

export default ActivateCloudStorage;